var _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueenUnderAttack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 90,
    y2: 90,
    stroke: "red",
    strokeWidth: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 10,
    x2: 10,
    y2: 90,
    stroke: "red",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueenUnderAttack);
export default __webpack_public_path__ + "static/media/queenUnderAttack.0a188d88e7e7a90d54248b637587c245.svg";
export { ForwardRef as ReactComponent };